import searchInput from './searchInput.vue';

export default searchInput;
